import React, { useEffect, useState } from "react";
import Dashboard from "../layouts/Dashboard";
import { Card, Col, Row } from "antd";
import { Button } from "reactstrap";
import axios from "../services/axios";
import { message } from "antd";
import moment from "moment";
import ReactLoading from "react-loading";
import { Pagination } from "antd";
import { DatePicker } from "antd";
import exportFromJSON from "export-from-json";
import swal from "sweetalert";
import { useLocation } from "react-router-dom";
import { createGlobalStyle } from "styled-components";
import isConsultant from "../services/isConsultant";

const { RangePicker } = DatePicker;

const InactiveCandidates = (props) => {
  const location = useLocation();

  const [defaultDate, setDefaultDate] = useState([]);
  const [csvData, setCsvData] = useState([]);
  const [load, setLoad] = useState(false);
  const disabledDate = (current) => {
    // 60 DAYS GAP AND DISABLE DATES IN FUTURE
    return (
      current.isBefore(moment().subtract(366, "day")) ||
      (defaultDate[0] && current > moment(defaultDate[0]).add(60, "days")) ||
      current > moment().endOf("day")
    );
  };

  useEffect(() => {
    loadCSV();
  }, [defaultDate]);

  const [current, setCurrent] = useState(1);

  const onChange = (page) => {
    console.log(page);
    setCurrent(page);
  };

  const loadCSV = async () => {
    setLoad(true);
    await axios
      .get(
        `/candidates/InActiveCandidates?StartDate=${
          defaultDate[0]
            ? defaultDate[0]?._i
            : moment(new Date()).format("YYYY-MM-DD")
        }&EndDate=${
          defaultDate[1]
            ? defaultDate[1]?._i
            : moment(new Date()).format("YYYY-MM-DD")
        }`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user.token")}`,
          },
        }
      )
      .then((res) => {
        const result = res.data.candidates;
        //  console.log("RES", res.data);
        const flattenArray = result?.map((ele) => {
          let flatObject = { ...ele };
          function flatten(obj, keyPrefix) {
            Object.keys(obj).forEach((key) => {
              if (typeof obj[key] === "object") {
                Object.assign(flatObject, obj[key]);
                delete flatObject[key];
              }
            });
          }
          flatten(ele, "");
          return flatObject;
        });
        const data = flattenArray;
        setCsvData(data);
        setLoad(false);
      })
      .catch((err) => {
        console.log(err);
        message.warning("Error Occured", 2);
        setLoad(false);
      });
  };

  const handleDate = (value, dateString) => {
    if (value === null) {
      setCurrent(1);
      setDefaultDate([
        moment(new Date()).format("YYYY-MM-DD"),
        moment(new Date()).format("YYYY-MM-DD"),
      ]);
    } else {
      setCurrent(1);
      let startDate = moment(dateString[0], "YYYY-MM-DD");
      let endDate = moment(dateString[1], "YYYY-MM-DD");

      if (moment(endDate).isAfter(moment(startDate).add(60, "days"))) {
        swal({
          title: "You can not select data more than 60 days",
          icon: "error",
        });
      } else {
        setDefaultDate([startDate, endDate]);
      }
    }
  };

  console.log("default date", defaultDate[0]?._i)

  const onOk = (value) => {
    // console.log("onOk:", value);
  };

  //CSV DATA
  const exportType = "csv";
  let fileName = `CANDIDATE_HISTORY_${moment(new Date()).format(
    "DD-MM-YYYY_HH:mm"
  )}`;

  // const downloadCSV = async() => {
  //   if(defaultDate.length === 0){
  //     swal({
  //       title: "Please select date range",
  //       icon: "error",
  //     })
  //   }
  //   else{
  //     const flattenArray =await csvData?.map(ele => {
  //       let flatObject = {...ele};
  //       function flatten(obj, keyPrefix) {
  //         Object.keys(obj).forEach(key => {
  //           if (typeof obj[key] === 'object') {
  //             Object.assign(flatObject, obj[key]);
  //             delete flatObject[key];
  //           }
  //         });
  //       }
  //       flatten(ele, '');
  //       return flatObject;
  //     });
  //     const data = flattenArray;
  //   setCurrent(1);
  //   exportFromJSON({ data, fileName, exportType });
  //   }
  // };

  const downloadCSV = async () => {
    const flattenArray = (data) => {
      if (!data) return [];
      return data.map((ele) => {
        let flatObject = { ...ele };
        function flatten(obj) {
          Object.keys(obj).forEach((key) => {
            if (typeof obj[key] === "object" && !Array.isArray(obj[key])) {
              Object.assign(flatObject, obj[key]);
              delete flatObject[key];
            } else if (Array.isArray(obj[key])) {
              console.log("inside array key", obj[key]);
              flatObject[key] = obj[key].toString();
            }
          });
        }

        flatten(ele);
        return flatObject;
      });
    };
    const data = flattenArray(csvData);
    setCurrent(1);
    exportFromJSON({ data, fileName, exportType });
  };

  return (
    <Dashboard title="Inactive Candidates">
      {load && (
        <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
      )}
      <div className="row p-3 border mb-2 bg-white cursor-pointer">
        <RangePicker
          format="YYYY-MM-DD"
          // defaultValue={[moment(), moment()]}
          onChange={handleDate}
          onOk={onOk}
          disabledDate={disabledDate}
          placeholder={[
            moment(new Date()).format("YYYY-MM-DD"),
            moment(new Date()).format("YYYY-MM-DD"),
          ]}
        />
        <div className="col-md-2">
          <button className="btn btn-primary btn-block" onClick={downloadCSV}>
            Download CSV
          </button>
        </div>
      </div>
    </Dashboard>
  );
};

export default InactiveCandidates;
